<template>
  <v-dialog v-model="show" persistent max-width="500">
    <v-card>
      <v-card-title class="text-h3">
        {{ $t('TARIFF_CHANGE_OFFER_TYPE_TITLE') }}
      </v-card-title>

      <v-card-text class="text-body-2">
        {{ $t('TARIFF_CHANGE_OFFER_TYPE_DESC') }}
      </v-card-text>

      <v-card-actions class="d-flex justify-end pa-4">
        <v-btn
          class="non-text-transformation link"
          tile
          large
          outlined
          color="primary"
          @click.stop="show = false"
        >
          {{ $t('TARIFF_CHANGE_OFFER_TYPE_BUTTON_CANCEL') }}
        </v-btn>

        <v-btn
          tile
          large
          class="ml-4 non-text-transformation link"
          color="primary"
          @click="convertOfferType(), (show = false)"
        >
          {{ $t('TARIFF_CHANGE_OFFER_TYPE_BUTTON_CONTINUE') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['value', 'info'],
  data() {
    return {
      newPrice: null,
    }
  },
  computed: {
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    convertOfferType() {
      this.$emit('onConvertOfferType')
    },
  },
}
</script>
